import React from 'react'
import BallySportsNBA from 'src/components/page/bally-sports-nba'
import { videos } from 'src/constants/videos'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <BallySportsNBA
    location={props.location}
    video={videos.bally_spurs.videoUrl}
    staticAnnotation={videos.bally_spurs.staticAnnotation}
    title="Watch San Antonio basketball live"
    subtitle="Stream the Spurs on FanDuel Sports Network Southwest"
    teamId={teamIds['San Antonio Spurs']}
  />
)
